import { WorkflowStageCode } from "@shuttlerock/api-types/federated";
import { generatePath } from "react-router";
import { Routes } from "./route-definitions";

/**
 * Where a project opens, from its concepts' workflow stages. Every project is a
 * concept-workflow project (docs/project-tracker-stage-based-navigation/SCOPE.md, D1): an
 * outstanding review is the top client action; otherwise any production or approved work
 * is worth viewing, on the project's creatives; otherwise the brief.
 */
export function getProjectUrl(
  projectKey: string,
  conceptStageCodes: readonly WorkflowStageCode[] = [],
): string {
  if (conceptStageCodes.includes(WorkflowStageCode.DeliveryReview)) {
    return generatePath(Routes.Revision.Creative, { creativeKey: null, projectKey });
  }
  if (
    conceptStageCodes.includes(WorkflowStageCode.Production) ||
    conceptStageCodes.includes(WorkflowStageCode.Approved)
  ) {
    return generatePath(Routes.Delivery.Concepts, { projectKey });
  }
  return generatePath(Routes.Projects.BriefingBase, { projectKey });
}
